<template>
  <div class="fix">
    <div class="conLeft fl w380">
      <classify @handleClickLi="handleClickLi" :organId="organ_id"></classify>
    </div>
    <div class="conRight fr w780">
      <searchResult ref="searchRef" :organId="organ_id"></searchResult>
    </div>
  </div>
</template>

<script>
import classify from "../components/goodCenter/classify";
import searchResult from "../components/goodCenter/searchResult";
import { mapActions, mapGetters } from "vuex";
export default {
  name: "comItem",
    props:{
        id:{
            type:String
        }
    },
    data(){
      return {
          organ_id:''
      }
    },
  components: {
    classify,
    searchResult,
  },
    watch:{
        'id':function (newValue){
            if(newValue){
                this.organ_id = newValue
            }
        }
    },
    asyncData({ store,route }) {
        let params = {
            type:8,
            zone_name:route.params.name
        }
        return store.dispatch("pageOrgMeta/setOrgMeta", [params, () => {}]);
    },
  computed: {
      ...mapGetters({
          getIsLoadIng: "pageOrgMeta/getIsLoadIng",
          getData: "pageOrgMeta/getData",
      }),

  },
  mounted() {
      const webName = this.$route.params.name;
      if (!this.getIsLoadIng){
          let parmas = {
              type:8,
              zone_name:webName
          }
          this.setOrgMeta([parmas,()=>{
              this.filteData();
          }])
      }else{
          this.filteData();
      }
  },
  methods: {
    ...mapActions({
        setOrgMeta:"pageOrgMeta/setOrgMeta"
    }),
      filteData(){
          let data = this.$store.state["pageOrgMeta"]["data"]
          console.log(data,'pageOrgMeta')
          document.title = data.meta ? data.meta.title :'';
          let head = document.getElementsByTagName('head');
          this.isLoading = false
          if(!document.querySelector('meta[name=description]')){
              let meta = document.createElement('meta');
              meta.name = 'description';
              meta.content = data.meta ? data.meta.description : '';
              head[0].appendChild(meta)
          }else{
              document.querySelector('meta[name=description]').setAttribute('content',data.meta ? data.meta.description : '')
          }
      },
    handleClickLi(item) {
      this.$refs.searchRef.setClassCode(item);
    },
  },
};
</script>

<style scoped>
</style>